import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class ReportAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.repository
   * @param {Function} deps.requestValueObject
   */
  constructor({config, repository, requestValueObject}) {
    super({config, repository, requestValueObject})
    this._config = config
    this._repository = repository
    this._requestValueObject = requestValueObject
  }

  /**
   * @return {Promise}
   */
  async execute({adId, queryTypeId, description, captchaToken}) {
    const requestVO = this._requestValueObject({
      adId,
      queryTypeId,
      description,
      captchaToken
    })
    return this._repository.reportAd(requestVO)
  }
}
